import { Button, Modal, ModalBody, Spinner } from "reactstrap";
import { MdWarningAmber } from "react-icons/md";

const migrationNotes = [
    "Your existing project will become inaccessible for editing once migration begins.",
    "You will need to reupload your floorplans and reposition all pins on the map.",
    "All existing pin information and details will be retained in the new project.",
    "Once you publish the migrated project, it will automatically replace the existing project.",
    "Your existing QR codes will continue to work, so there is no need to reprint any QR posters.",
];

const MigrateProjectModal = ({ modal, toggle, onConfirm, loading }) => {
    return (
        <Modal isOpen={modal} toggle={loading ? undefined : toggle} size='lg' style={{ zIndex: '999999 !important' }} centered>
            <ModalBody>
                <div className="d-flex align-items-center mb-3">
                    <span style={{ display: 'inline-flex', padding: '8px', borderRadius: '6px', backgroundColor: '#dff1fa', color: '#26A3DB', marginRight: '12px' }}>
                        <MdWarningAmber size={22} />
                    </span>
                    <h5 className="f-w-600 mb-0" style={{ fontSize: '1.5rem' }}>Migrate to New Platform</h5>
                </div>
                <p style={{ fontSize: '1rem', color: '#000', marginBottom: '12px' }}>
                    Are you sure you want to migrate this project to the new platform?
                </p>
                <p style={{ fontSize: '0.875rem', color: '#6a6d73', fontWeight: 600, marginBottom: '8px' }}>
                    Please be aware of the following before proceeding:
                </p>
                <ul style={{ fontSize: '0.875rem', color: '#6a6d73', paddingLeft: '20px', marginBottom: 0, listStyleType:"initial" }}>
                    {migrationNotes.map((note, index) => (
                        <li key={index} style={{ marginBottom: '6px' }}>{note}</li>
                    ))}
                </ul>
                <div className="form-group text-right" style={{ marginTop: "30px" }}>
                    <Button color="secondary" className="btn btnCancel mr-3" onClick={toggle} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="primary" className="btn btn-primary float-right" onClick={onConfirm} disabled={loading}>
                        {loading ? (
                            <>
                                <p style={{ opacity: '0', position: 'relative' }}>Confirm Migration</p>
                                <Spinner
                                    className="ml-2 spinner-style"
                                    color="light"
                                />
                            </>
                        ) : (
                            <>Confirm Migration</>
                        )}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}
export default MigrateProjectModal
